import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { MetaDataService } from "../../services/metadata.service";
import { map } from "rxjs/operators";

@Component({
  selector: "app-page-accessibility",
  templateUrl: "./page-accessibility.component.html",
  styleUrls: ["./page-accessibility.component.scss"]
})
export class PageAccessibilityComponent implements OnInit, OnDestroy {
  page$;
  content;

  constructor(private route: ActivatedRoute, private mds: MetaDataService) {
    // Get page content
    this.page$ = this.route.data.pipe(map(r => r.content));
    this.page$.subscribe(page => {
      this.content = page;

      // set metadata
      this.mds.setMetaData(this.content);
    });
  }

  ngOnInit() {
    window.scrollTo(0, 0);
  }

  ngOnDestroy() {
    if (this.page$) {
      this.page$.unsubscribe();
    }
  }
}
